module.exports = __webpack_public_path__ + "img/background-2.82cec37c.png";